export default "__VITE_ASSET__BaALW61m__"